import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  cardsContainer: {
    display: 'grid',
    margin: '16px',
    marginLeft: '16px',
    width: '95%',
    columnGap: 30,
    [theme.breakpoints.down('md')]: {
      margin: '10px auto',
      rowGap: 10,
    },
  },
  gridTemplateColumns: {
    gridTemplateColumns: '1fr 1fr 1fr',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  gridTemplateColumnsMinimalist: {
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  infoCard: {
    padding: '5%',
    minHeight: 90,
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 2fr',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  infoInterestContainer: {
    display: 'flex',
    marginInline: '16px',
    justifyContent: 'flex-end',
    width: '95%',
    gap: 30,
    [theme.breakpoints.down('sm')]: {
      margin: '20px auto',
      gap: 10,
      justifyContent: 'flex-start',
    },
  },
}));

export default useStyles;
